import { componentViewEventFactorSelection, componentViewEventFeedbackModal, componentViewEventGeneralError, componentViewEventQr, componentViewEventSignInLoader } from "../../common/rio/rio";
import { getNotificationLabels } from "../../components/FeedbackModals/Notification/notification.utils";
export { registerRouteChange };
function registerRouteChange(store) {
  var currentRoute = store.getState().router.current_route;
  handleRouteChange(currentRoute);
  return store.subscribe(function () {
    var state = store.getState();
    var route = state.router.current_route;
    if (route != currentRoute) {
      handleRouteChange(route);
      currentRoute = route;
    }
  });
}
function handleRouteChange(route) {
  switch (route) {
    default:
      componentViewEventFactorSelection();
      return;
    case 'general_error':
      componentViewEventGeneralError(route);
      return;
    case 'os_push_declined':
      {
        var _getNotificationLabel = getNotificationLabels('os_push_declined'),
          title = _getNotificationLabel.title;
        componentViewEventFeedbackModal('os_push_declined', title);
        return;
      }
    case 'app_push_declined':
      {
        var _getNotificationLabel2 = getNotificationLabels('app_push_declined'),
          _title = _getNotificationLabel2.title;
        componentViewEventFeedbackModal('app_push_declined', _title);
        return;
      }
    case 'push_sent':
      {
        var _getNotificationLabel3 = getNotificationLabels('success'),
          _title2 = _getNotificationLabel3.title;
        componentViewEventFeedbackModal('success', _title2);
        return;
      }
    case 'signing_in':
      componentViewEventSignInLoader();
      return;
    case 'qr':
      componentViewEventQr();
      return;
  }
}